import * as React from 'react';
import { fetchProjectRequest } from '../../app/Projects/actions';
import { store } from '../../store';
import ProjectDialog from '../Search/SearchResults/ProjectResult/ProjectDialog';

interface IPublcProjectsProps {
  projects: any[];
}

const PublicProjects: React.FC<IPublcProjectsProps> = ({ projects }) => {
  const [programme, setProgramme] = React.useState('all');
  const [projectName, setProjectName] = React.useState('');
  const [sortBy, setSortBy] = React.useState('startDate');

  const normalizeDate = (dateStr: string) => {
    if (!dateStr || dateStr === 'N/A' || dateStr === 'null' || dateStr === 'undefined') {
      return null;
    }
    
    // Handle MM/DD/YYYY format
    if (dateStr.includes('/')) {
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];
        return `${year}-${month}-${day}`;
      }
    }
    
    // Already in YYYY-MM-DD format or other standard format
    return dateStr;
  };

  const normalizedProjects = React.useMemo(() => {
    return projects.map(project => ({
      ...project,
      startDate: normalizeDate(project.startDate),
      endDate: normalizeDate(project.endDate)
    }));
  }, [projects]);

  const filteredAndSortedProjects = React.useMemo(() => {
    return normalizedProjects
      .filter((project: any) => programme === 'all' || project.program === programme)
      .filter(
        (project: any) =>
          projectName === '' || project.title?.toLowerCase().includes(projectName.toLowerCase()),
      )
      .sort((a: any, b: any) => {
        if (sortBy === 'startDate' || sortBy === 'endDate') {
          const dateA = a[sortBy] ? new Date(a[sortBy]) : new Date('1900-01-01');
          const dateB = b[sortBy] ? new Date(b[sortBy]) : new Date('1900-01-01');
          return dateA.getTime() - dateB.getTime();
        }
        return a[sortBy]?.localeCompare(b[sortBy]) || 0;
      });
  }, [normalizedProjects, programme, projectName, sortBy]);

  const handleProjectClick = (projectId: string) => {
    store.dispatch(fetchProjectRequest(Number.parseInt(projectId)));
  };
  return (
    <div className="public-projects-parent org-container">
      <span style={{ color: 'red', fontWeight: 'bold', width: '100%', fontSize: '16px' }}>
        List of projects ({projects?.length || 0})
      </span>
      {projects?.length !== 0 && (
        <div className="projects-filter-sorting">
          <div className="filter-projects">
            <div>
              <input
                type="search"
                placeholder="Search project name..."
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
              />
            </div>
            <div>
              <b>Program: </b>
              <select value={programme} onChange={(e) => setProgramme(e.target.value)}>
                <option value="all">All</option>
                {[...new Set(projects.map((project) => project?.program))]
                  .filter(Boolean)
                  .map((program, index) => (
                    <option key={index} value={program}>
                      {program}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="sort-projects">
            <div>
              <b>Sort by: </b>
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value="startDate">Start Date</option>
                <option value="endDate">End Date</option>
                <option value="program">Program</option>
              </select>
            </div>
          </div>
        </div>
      )}
      <div className="public-projects-data">
        {filteredAndSortedProjects?.length !== 0 ? (
          filteredAndSortedProjects.map((project, index) => (
            <button key={index} className="project-container" onClick={() => handleProjectClick(project?.id)}>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{project?.acronym}</span>
              <span>{project?.title}</span>
              <span>Program: {project?.program}</span>
              <span>
                {project.startDate || project.endDate
                  ? `${project.startDate || 'N/A'} - ${project.endDate || 'N/A'}`
                  : ''}
              </span>
            </button>
          ))
        ) : (
          <span style={{ marginLeft: '45%', marginTop: '20%' }}>No data available</span>
        )}
      </div>
      <ProjectDialog />
    </div>
  );
};

export const PublicProjectsData = React.memo(PublicProjects);
